import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TaskState } from '../../../models/app/precall/precall-state';

@Component({
  selector: 'app-task-state',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './task-state.component.html',
})
export class TaskStateComponent {
  state = input.required<TaskState>();
  label = input<string | undefined>();
}
